forgotPasswordController.$inject = [
  "Authentication.forgotPasswordServices",
  "$scope",
  "$state"
];

function forgotPasswordController(forgotPasswordServices, $scope, state) {
  var self = this;
  self.sendButton = true;
  self.resendButton = false;

  self.company = {
    captchaId: null
  };

  self.getCaptcha = async function () {
    let parameter = {
      type: "captcha",
      id: self.company.captchaId
    };

    await forgotPasswordServices.get(parameter).$promise.then(
      response => {
        self.captchaImage = "data:image/png;base64," + response.content.captchaImage;
        self.company.captchaId = response.content.captchaId;
      },
      errResponse => {
        iziToast.show({
          message: errResponse.data.message,
          theme: "light",
          color: "red"
        });
        console.log("fail createYear");
      }
    );
  };
  self.getCaptcha();

  self.send = async function (company, form) {
    if (form.$valid) {
      self.sendButton = false;
      // self.resendButton = true;

      let parameter = {
        type: "accounts",
        id: "forget-password"
      };

      await forgotPasswordServices.create(parameter, company).$promise.then(
        response => {
          state.go("Authentication.ChangePassword", {
            id: response.message
          });
          company = {};
          form.$setUntouched();
          form.$setPristine();
          // iziToast.show({
          //     message: response.message,
          //     theme: 'light',
          //     color: 'green',
          // });

          // self.resend();

          // textDisable();
        },
        errResponse => {
          self.getCaptcha();
          iziToast.show({
            message: errResponse.data.message,
            theme: "light",
            color: "red"
          });
          console.log("fail createYear");
        }
      );
    }
    // else {
    //     iziToast.show({
    //         message: 'فرم را تکمیل کنید.',
    //         theme: 'light',
    //         color: 'red',
    //     });
    // }
  };

  self.resend = function (company, form) {
    self.send(company, form);
    textDisable();
  };

  const textDisable = function () {
    let counterBtn = document.getElementById("counter-btn");
    let el = document.getElementById("seconds-counter");

    self.resendButton = true;
    counterBtn.setAttribute("disabled", true);
    let seconds = 5;
    el.innerText = "ارسال مجدد " + "(پس از" + seconds + " ثانیه)";

    function decrementSeconds() {
      seconds -= 1;
      el.innerText = "ارسال مجدد " + "(پس از" + seconds + " ثانیه)";
      if (seconds == 0) {
        clearInterval(stop);
        counterBtn.removeAttribute("disabled");
        el.innerText = "ارسال مجدد ";
        return self.disable;
      }
    }

    let stop = setInterval(decrementSeconds, 1000);
  };

  $scope.otpInput = {
    size: 6,
    type: "text",
    onDone: function (value) {
      let parameter = {
        type: "Account",
        id: "signup",
        routeParams: "phone",
        routeParams2: "verify"
      };
      forgotPasswordServices
        .create(parameter, {
          code: value,
          userId: self.userId
        })
        .$promise.then(
          response => {
            state.go("Authentication.ChangePassword", {
              id: self.userId,
              code: value
            });
          },
          errResponse => {
            iziToast.show({
              message: errResponse.data.message,
              theme: "light",
              color: "red"
            });
            console.log("fail createYear");
          }
        );
    },
    onChange: function (value) {
      console.log(value);
    }
  };
}

module.exports = ngModule => {
  ngModule.controller(
    "Authentication.forgotPasswordController",
    forgotPasswordController
  );
};
